var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 9 16 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 12.7v4.264c0 .276.175.36.39.187l2.509-2.006c.216-.173.216-.453 0-.625L7.39 12.513c-.215-.173-.39-.089-.39.187M8 9c-.55 0-1 .561-1 1l7.568 6.024a.66.66 0 0 0 .784.002L23 10c0-.439-.45-1-1-1zm12.1 6.145 2.509 2.006c.216.173.391.089.391-.187V12.7c0-.276-.175-.36-.391-.187L20.1 14.52c-.215.172-.215.452 0 .625m-2.201 1.136-2.509 2.006a.65.65 0 0 1-.781 0L12.1 16.281a.65.65 0 0 0-.781-.001L7 19.729V20c0 .439.45 1 1 1h14c.55 0 1-.561 1-1v-.271l-4.319-3.449a.66.66 0 0 0-.782.001"
})));
export default SvgMailSolid;